import React from 'react'
import styled from '@emotion/styled'
import { graphql } from 'gatsby'

import { Paragraph, ParagraphComponent } from '../types'
import Container from '../../Container'
import Button from '../../ui/Button'
import SectionHeader from '../../SectionHeader'
import { media } from '../../../styles/variables'

interface ActionTag {
	drupal_internal__tid: number
	name: string
	description: {
		processed: string
	}
	field_link: {
		uri: string
		link: string
	}
}

interface ActionsParagraph extends Paragraph {
	field_title: string
	relationships: {
		field_tag_multiple: ActionTag[]
	}
}

const Actions: ParagraphComponent<ActionsParagraph> = ({ className, paragraph }) => (
	<Container className={className}>
		<SectionHeader>{paragraph.field_title}</SectionHeader>
		<ol>
			{paragraph.relationships.field_tag_multiple.map(action => (
				<li key={action.drupal_internal__tid}>
					<div className="link">
						<Button link={action.field_link}>{action.name}</Button>
					</div>
					<div className="break" />
					<div className="body" dangerouslySetInnerHTML={{ __html: action.description.processed }} />
				</li>
			))}
		</ol>
	</Container>
)

export default styled(Actions)`
	ol {
		counter-reset: front-page;
		list-style: none;
		padding-left: 0;
	}

	li {
		counter-increment: front-page;
		display: flex;
		flex-wrap: wrap;
		margin-bottom: var(--spacing);
		align-items: center;

		&:before {
			content: counter(front-page);
			background-color: var(--clr-dark);
			color: #fff;

			border-radius: 50%;
			font-family: Gilroy-Heavy;
			font-size: 3rem;
			text-align: center;

			display: block;
			width: 4rem;
			height: 4rem;
			margin-right: var(--spacing-sm);
			flex-shrink: 1;
		}
	}

	.link {
		flex-basis: 0;
		flex-grow: 10;

		${media.up('sm')} {
			max-width: 300px;
		}
	}

	.link > * {
		width: 100%;
	}

	.body {
		padding: var(--spacing-sm);
		flex: 1;
	}

	.break {
		${media.up('sm')} {
			display: none;
		}

		flex-basis: 100%;
		width: 0;
	}

	p {
		margin-bottom: 0;
	}
`

export const query = graphql`
	fragment ActionsParagraph on paragraph__actions {
		drupal_internal__id
		field_title
		relationships {
			field_tag_multiple {
				drupal_internal__tid
				name
				description {
					processed
				}
				field_link {
					uri
					link
				}
			}
		}
	}
`
